import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import apiUrl from "../../Apiurl";
import stilePulsanti from "../../interfaccia/stilePulsanti";

export const NOMI_FONTE_IMPORT_ORDINI = {
  VIG: "Viglietti",
  BOT: "Bottero",
};

// Import manuale alternativo a quello schedulato, da usare quando la
// comunicazione con il sito si blocca: si esegue in PrestaShop la stessa
// query del cron e si carica il CSV esportato.
function CSVuploadImportOrdini({ setPopUpWindow, fonteOrdine }) {
  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [numeroQuery, setNumeroQuery] = useState(null);
  const [inCaricamento, setInCaricamento] = useState(false);
  const [risultatoOperazione, setRisultatoOperazione] = useState(
    "In attesa dell'upload",
  );
  const [risultatoImport, setRisultatoImport] = useState(null);
  const { getAccessTokenSilently } = useAuth0();

  const { tastoChiudiAspetto } = stilePulsanti;
  const nomeFonte = NOMI_FONTE_IMPORT_ORDINI[fonteOrdine] || fonteOrdine;

  useEffect(() => {
    let attivo = true;
    const caricaConfig = async () => {
      try {
        const token = await getAccessTokenSilently();
        const resp = await axios.get(
          apiUrl + "/logistica/csv/importOrdini/config",
          { headers: { Authorization: "Bearer " + token } },
        );
        const config = (resp.data || []).find(
          (riga) => riga.fonteOrdine === fonteOrdine,
        );
        if (attivo) setNumeroQuery(config?.report || null);
      } catch (e) {
        console.error("Errore lettura numero query import ordini:", e);
      }
    };
    caricaConfig();
    return () => {
      attivo = false;
    };
  }, [getAccessTokenSilently, fonteOrdine]);

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
  };

  const handleSubmission = async () => {
    if (!selectedFile) {
      setRisultatoOperazione("Seleziona prima un file CSV");
      return;
    }
    const formData = new FormData();
    formData.append("uploaded_file", selectedFile);
    formData.append("fonte_ordine", fonteOrdine);

    setInCaricamento(true);
    setRisultatoImport(null);
    setRisultatoOperazione("Import in corso...");
    try {
      const token = await getAccessTokenSilently();
      const resp = await axios.post(
        apiUrl + "/logistica/csv/importOrdini",
        formData,
        { headers: { Authorization: "Bearer " + token } },
      );
      const dati = resp.data || {};
      setRisultatoImport(dati);
      setRisultatoOperazione(
        `Import completato: inseriti ${dati.arrOrdiniInseriti?.length ?? 0}` +
          ` - già presenti ${dati.arrOrdiniPresenti?.length ?? 0}` +
          ` - errori ${dati.arrErrori?.length ?? 0}`,
      );
    } catch (error) {
      console.error("Errore import manuale ordini:", error);
      const permessoMancante = error?.response?.data?.missing_permission;
      const dettaglio =
        (permessoMancante && "permesso mancante " + permessoMancante) ||
        error?.response?.data?.detail ||
        error?.response?.data?.error ||
        error?.message;
      setRisultatoOperazione("Errore durante l'import: " + dettaglio);
    } finally {
      setInCaricamento(false);
    }
  };

  return (
    <div className="flex pa3 shadow-5 br4">
      {setPopUpWindow && (
        <button
          className="dim tastoInputOrizzontale br3"
          onClick={(e) => {
            e.preventDefault();
            setPopUpWindow(false);
          }}
        >
          {tastoChiudiAspetto}
        </button>
      )}
      <div className="w-50 pa3">
        <h1>Importazione manuale ordini {nomeFonte}</h1>
        <p>
          Da usare quando l'import schedulato non riesce a comunicare con il
          sito {nomeFonte}. Esegui su PrestaShop {nomeFonte} la query{" "}
          <b>{numeroQuery ?? "…"}</b> ed esporta il risultato in CSV: accetta il
          file scaricato direttamente da PS.
        </p>
        <input type="file" accept=".csv" name="file" onChange={changeHandler} />
        {isFilePicked ? (
          <div>
            <p>Nome del file: {selectedFile.name}</p>
            <p>Tipo file: {selectedFile.type}</p>
            <p>Dimensione in bytes: {selectedFile.size}</p>
            <p>
              Data ultima modifica:{" "}
              {selectedFile.lastModifiedDate.toLocaleDateString()}
            </p>
          </div>
        ) : (
          <p>Seleziona un file</p>
        )}
        <div>
          <button
            onClick={handleSubmission}
            disabled={inCaricamento}
            className="f6 link dim ba b--dark-green ph3 pv2 mt4 dib white bg-dark-green br3 mr2 w-70 center"
          >
            Carica
          </button>
        </div>
        <p>{risultatoOperazione}</p>
      </div>
      <div className="w-50 ml2 pa3 bl bordoColAlt">
        {risultatoImport && (
          <pre className="pa3 max70 sezioneConScroll">
            {JSON.stringify(risultatoImport, null, 2)}
          </pre>
        )}
      </div>
    </div>
  );
}

export default CSVuploadImportOrdini;
